import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export type Lang = 'es' | 'en';

const STORAGE_KEY = 'packcert.lang';

@Injectable({ providedIn: 'root' })
export class LanguageService {
  readonly available: Lang[] = ['es', 'en'];

  constructor(private readonly translate: TranslateService) {}

  init(): void {
    this.translate.addLangs(this.available);
    this.translate.setDefaultLang('es');
    const stored = localStorage.getItem(STORAGE_KEY) as Lang | null;
    if (stored && this.available.includes(stored)) {
      // El usuario ya eligió idioma manualmente: se respeta.
      this.apply(stored);
    } else {
      // Primera visita: según el navegador. Español -> ES; cualquier otro -> EN.
      // No se persiste, para reevaluar el idioma del navegador en cada visita
      // hasta que el usuario elija manualmente con el toggle.
      const browser = this.translate.getBrowserLang();
      this.apply(browser === 'es' ? 'es' : 'en');
    }
  }

  get current(): Lang {
    return (this.translate.currentLang as Lang) ?? 'es';
  }

  /** Cambio manual (toggle ES/EN): aplica y persiste la preferencia. */
  use(lang: Lang): void {
    this.apply(lang);
    localStorage.setItem(STORAGE_KEY, lang);
  }

  /** Aplica el idioma sin persistirlo. */
  private apply(lang: Lang): void {
    this.translate.use(lang);
    document.documentElement.lang = lang;
  }
}
